import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Container, Box, Typography, styled } from "@mui/material";
import Footer from "../componentsPeopletech/Footer/Footer";

const TermsOfService = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  const baseUrl = 'https://www.peoplefortech.com';

  const TermsContainer = styled(Container)(({ theme }) => ({
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    backgroundColor: '#ffffff',
    maxWidth: '900px',
  }));

  const Title = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    fontSize: '2.5rem',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  }));

  const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    fontSize: '1.5rem',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    color: '#1c2859',
  }));

  const SectionText = styled(Typography)(({ theme }) => ({
    fontSize: '1rem',
    lineHeight: 1.8,
    color: '#414141',
    marginBottom: theme.spacing(2),
  }));

  const LastUpdated = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    color: '#666',
    fontStyle: 'italic',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  }));

  return (
    <>
      <Helmet>
        <title>Términos de Servicio - PeopleForTech</title>
        <meta name="description" content="Términos de Servicio de PeopleForTech" />
        <link rel="canonical" href={`${baseUrl}/terms-of-service`} />
        <html lang={currentLang} />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/terms-of-service`} />
        <meta property="og:title" content="Términos de Servicio - PeopleForTech" />
        <meta property="og:description" content="Términos de Servicio de PeopleForTech" />
      </Helmet>
      
      <TermsContainer>
        <Title variant="h1">Términos de Servicio</Title>
        <LastUpdated>Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</LastUpdated>

        <SectionTitle variant="h2">1. Aceptación de los Términos</SectionTitle>
        <SectionText>
          Al acceder y utilizar el sitio web de PeopleForTech (www.peoplefortech.com), 
          usted acepta cumplir con estos Términos de Servicio y todas las leyes y 
          regulaciones aplicables. Si no está de acuerdo con alguno de estos términos, 
          no debe utilizar nuestros servicios.
        </SectionText>

        <SectionTitle variant="h2">2. Descripción del Servicio</SectionTitle>
        <SectionText>
          PeopleForTech ofrece servicios de consultoría en inteligencia artificial, 
          desarrollo de software de IA y servicios de SEO de IA. Proporcionamos contenido 
          educativo, consejos y recursos relacionados con el uso de inteligencia artificial 
          en desarrollo de software, creación de videos e imágenes, y aplicaciones empresariales.
        </SectionText>

        <SectionTitle variant="h2">3. Uso del Sitio Web</SectionTitle>
        <SectionText>
          Usted se compromete a utilizar nuestro sitio web únicamente para fines legales 
          y de manera que no infrinja los derechos de terceros ni restrinja o inhiba el 
          uso y disfrute del sitio web por parte de otros usuarios.
        </SectionText>

        <SectionTitle variant="h2">4. Propiedad Intelectual</SectionTitle>
        <SectionText>
          Todo el contenido del sitio web, incluyendo pero no limitado a textos, gráficos, 
          logotipos, iconos, imágenes, clips de audio, descargas digitales y compilaciones 
          de datos, es propiedad de PeopleForTech o de sus proveedores de contenido y está 
          protegido por las leyes de derechos de autor.
        </SectionText>

        <SectionTitle variant="h2">5. Limitación de Responsabilidad</SectionTitle>
        <SectionText>
          PeopleForTech no será responsable de ningún daño directo, indirecto, incidental, 
          especial o consecuente que resulte del uso o la imposibilidad de usar nuestros 
          servicios o el contenido de nuestro sitio web.
        </SectionText>

        <SectionTitle variant="h2">6. Modificaciones de los Términos</SectionTitle>
        <SectionText>
          Nos reservamos el derecho de modificar estos términos en cualquier momento. 
          Las modificaciones entrarán en vigor inmediatamente después de su publicación 
          en el sitio web. Se recomienda revisar periódicamente estos términos.
        </SectionText>

        <SectionTitle variant="h2">7. Contacto</SectionTitle>
        <SectionText>
          Si tiene preguntas sobre estos Términos de Servicio, puede contactarnos a través 
          de: contact@peoplefortech.com
        </SectionText>

        <SectionTitle variant="h2">8. Ley Aplicable</SectionTitle>
        <SectionText>
          Estos términos se regirán e interpretarán de acuerdo con las leyes aplicables, 
          sin dar efecto a ningún principio de conflictos de leyes.
        </SectionText>
      </TermsContainer>
      <Footer />
    </>
  );
};

export default TermsOfService;

